<template>
  <transition name="loader">
    <div :id="id ? id : 'loaderspinwrap'" class="loaderspinwrap">
      <div class="loaderspin" :class="{ withtext: text, '': !text }"></div>
      <p v-if="text">{{ text }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'loader-spin',
  props: {
    text: { type: String, default: '' },
    id: { type: String, default: '' },
  },
};
</script>
